import { useCurrentCommunityId } from '@communities/community/hooks';
import { useCommunityTopics } from '@communities/content-management/hooks';
import type { PanelFilters } from '@content-search/domain';
import { MultiSelect } from '@soteria/design-system-ve';
import { useMemo, useCallback } from 'react';

import * as styles from './FilterPanel.css';

interface TopicsFilterProps {
  panelFilters: PanelFilters;
  updateFilters: (updates: Partial<PanelFilters>) => void;
  isLoading: boolean;
}

// Transform topics for MultiSelect component
const getTopicOptions = (topics: Array<{ name: string }>) =>
  topics.map(topic => ({
    id: topic.name,
    label: topic.name,
    value: topic.name,
  }));

export function TopicsFilter({ panelFilters, updateFilters, isLoading }: TopicsFilterProps) {
  const communityId = useCurrentCommunityId();
  const { topics, loading: isTopicsLoading } = useCommunityTopics(communityId);

  const topicOptions = useMemo(() => getTopicOptions(topics), [topics]);

  const handleTopicsChange = useCallback(
    (selectedTopics: string[]) => {
      updateFilters({ topics: selectedTopics });
    },
    [updateFilters]
  );

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterLabel}>Topics</div>
      <MultiSelect
        searchable
        aria-label="Filter by topics"
        disabled={isLoading || isTopicsLoading}
        options={topicOptions}
        placeholder="All"
        searchPlaceholder="Search topics..."
        selectedValues={panelFilters.topics || []}
        onSelectionChange={handleTopicsChange}
      />
    </div>
  );
}
